import { Select } from 'antd';
import ClearIcon from '../clearIcon/ClearIcon';

const MY_CLEAR = { clearIcon: <ClearIcon /> };

const MySelect = ({ style, width, block, allowClear, ...otherProps }) => {
  const styleLocal = { ...style, width: block ? '100%' : width || '' };
  return (
    <Select
      {...otherProps}
      allowClear={allowClear ? MY_CLEAR : false}
      style={styleLocal}
    />
  );
};

export default MySelect;
